import React, { useEffect, useState } from "react";
import dataService from "../networks/api/service/dataService";
import { Typography } from "antd";
import GreivanceTable from "../components/GreivanceTable";

const { Title } = Typography;

function AssemblyGreivanceList() {
  const [grievances, setGrievances] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch grievances automatically on page load
  const fetchGrievances = async () => {
    setLoading(true);
    try {
      const res = await dataService.getAssemblyGreivance();
      console.log("API Response:", res.data);

      const formattedData = res.data.map((item) => ({
        _id: item._id,
        email: item.email,
        nameOfApplicant: item.nameOfApplicant,
        mobileNo: item.mobileNo,
        problemRelatedToSection: item.problemRelatedToSection,
        levelOfIssue: item.levelOfIssue,
        status: item.status,
        descriptionOfProbles: item.descriptionOfProbles,
        authorityToBeSattled: item.authorityToBeSattled,
        contactPersonMobileNo: item.contactPersonMobileNo,
        takenBy : item.takenBy,
        district: item.district,        // was missing
        mandal: item.mandal,            // was missing
        ward: item.ward,                // was missing
        assignedTo: item.assignedTo,    // needed for the Assigned To dropdown to prefill
        docs: item.docs, 
        constituencyName: item.constituencyName,
        adminName: item.adminName,
        adminId: item.adminId,
        statusHistory: item.statusHistory,
        // isAdminAssigned: item.isAdminAssigned ? "Assigned" : "Not Assigned",
      }));

      setGrievances(formattedData);
    } catch (error) {
      console.error("Error fetching grievances:", error);
      setGrievances([]);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchGrievances(); // Fetch data on component mount
  // }, []);

  // // Debugging: Monitor state updates
  // useEffect(() => {
  //   console.log("Updated grievances state:", grievances);
  // }, [grievances]);

  // Fetch grievances when component mounts
  useEffect(() => {
    // const fetchData = async () => {
    //   await fetchGrievances();
    // };
    // fetchData();
    fetchGrievances();
  }, []);

  return (
    <div>
      {/* <h2>Grievances</h2> */}
      <GreivanceTable grievances={grievances} loading={loading} />
    </div>
  );
}

export default AssemblyGreivanceList;
